export default "__VITE_ASSET__ZL8F0ZY6__"